'use client'

import { FileQuestion, Home, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import Link from 'next/link'

export default function NotFound() {
  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center gap-2">
            <FileQuestion className="h-5 w-5 text-gray-600" />
            <CardTitle>Page not found</CardTitle>
          </div>
          <CardDescription>
            Sorry, we couldn&apos;t find the page you&apos;re looking for. It may have been moved or deleted.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-2">
            <Link href="/">
              <Button variant="default">
                <Home className="h-4 w-4 mr-2" />
                Go home
              </Button>
            </Link>
            <Button variant="outline" onClick={() => window.history.back()}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go back
            </Button>
          </div>
          
          <div className="text-sm text-gray-600">
            <p>Here are some helpful links instead:</p>
            <ul className="mt-2 space-y-1">
              <li>
                <Link href="/dashboard" className="text-sky-600 hover:underline">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link href="/flights" className="text-sky-600 hover:underline">
                  Flights
                </Link>
              </li>
              <li>
                <Link href="/aircraft" className="text-sky-600 hover:underline">
                  Aircraft
                </Link>
              </li>
              <li>
                <Link href="/maintenance" className="text-sky-600 hover:underline">
                  Maintenance
                </Link>
              </li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}